"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIntersectionObserver = void 0;
var _react = require("react");
var useIntersectionObserver = function useIntersectionObserver(callback, options) {
  var targetRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var observer = new IntersectionObserver(callback, options);
    var currentTarget = targetRef.current;
    if (currentTarget) {
      observer.observe(currentTarget);
    }
    return function () {
      if (currentTarget) {
        observer.unobserve(currentTarget);
      }
    };
  }, [targetRef, callback, options]);
  return targetRef;
};
exports.useIntersectionObserver = useIntersectionObserver;